import * as React from "react"
const transfer = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={35} height={35} fill="none" {...props}>
        <g>
            <path
                fill="#6941C6"
                d="M23.333 23.334V17.5l7.292 7.292-7.292 7.292V26.25h-17.5v-2.916h17.5ZM11.667 2.917v5.832l17.5.001v2.917h-17.5V17.5L4.375 10.21l7.292-7.292Z"
            />
        </g>
    </svg>
)
export default transfer
